import type { ReactNode } from 'react';
import { createContext } from 'react';

import type { CurrentUserQuery, JWTContextUser } from '@savvy/deprecated-shared/api/user-api';
import type { ResultOf } from '@savvy/deprecated-shared/gql-compat';
import type { LoginData } from '@savvy/deprecated-shared/utils/savvy-auth';

export type JWTContextState = {
  err?: string;
  isInitialized: boolean;
  isAuthenticated: boolean;
  user: JWTContextUser | null;
};

type NewCurrentUserAndJWTContextUser = JWTContextUser & {
  newCurrentUserData: ResultOf<typeof CurrentUserQuery> | undefined;
};

export type LoginReturn = {
  loginErr?: string;
};

export type AuthContextValue = {
  platform: 'JWT';
  login: (data: LoginData) => Promise<LoginReturn>;
  logout: () => Promise<boolean>;
  update: (user: JWTContextUser | NewCurrentUserAndJWTContextUser) => Promise<void>;
  reauth: () => Promise<void>;
} & JWTContextState;

export type AuthProviderProps = {
  children: ReactNode;
  readonly inviteToken?: string | string[];
};

const initialState: JWTContextState = {
  err: undefined,
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

export const AuthContext = createContext<AuthContextValue>({
  ...initialState,
  platform: 'JWT',
  login: () => Promise.resolve({}),
  update: () => Promise.resolve(),
  logout: () => Promise.resolve(false),
  reauth: () => Promise.resolve(),
});

export const AuthConsumer = AuthContext.Consumer;
